import { InfosecLevel } from "@istari-frontend/resource/model";

import { cn } from "~/utils/cn";
import { formatInfosecLevelName } from "~/utils/infosec";
import {
  infosecLevelUsesBorder,
  resolveInfosecThemeBackground,
  resolveInfosecThemeForeground,
} from "~/utils/infosec-display-color";

type ClassificationBannerSize = "sm" | "default";

interface ClassificationBannerProps {
  level: InfosecLevel;
  label: string;
  size?: ClassificationBannerSize;
  className?: string;
}

const sizeStyles: Record<ClassificationBannerSize, { container: string; label: string; level: string }> = {
  sm: {
    container: "h-6",
    label: "text-xs",
    level: "text-xs",
  },
  default: {
    container: "h-full",
    label: "text-xs",
    level: "text-sm",
  },
};

export function ClassificationBanner({ level, label, size = "default", className }: ClassificationBannerProps) {
  const styles = sizeStyles[size];
  const backgroundColor = resolveInfosecThemeBackground(level.name, level.displayColor);
  const foregroundColor = resolveInfosecThemeForeground(level.name, level.displayColor);
  const showBorder = infosecLevelUsesBorder(level.name, level.displayColor);

  return (
    <div
      className={cn(
        "group grid grid-cols-[1fr_auto_1fr] items-center rounded-sm px-3",
        styles.container,
        showBorder && "border-border border",
        className,
      )}
      style={{ backgroundColor, color: foregroundColor }}
    >
      <span
        className={cn(
          "truncate font-mono opacity-0 transition-opacity duration-200 ease-out group-hover:opacity-100",
          styles.label,
        )}
      >
        {label}
      </span>
      <span className={cn("font-mono", styles.level)}>{formatInfosecLevelName(level.name)}</span>
      <span />
    </div>
  );
}
